import { BaseJsonObject, XyoWorldBase, XyoWorldGeotokens } from '@xyo-network/sdk-xyoworld-js'

import EntitySortOrder from './EntitySortOrder'
import { EntityType, XyoWorldEntity } from './XyoWorldEntity'

export type EntitiesJsonObject = BaseJsonObject

class Entities extends XyoWorldBase<EntitiesJsonObject> {
  private entities?: Map<string, XyoWorldEntity>
  private geotokens?: XyoWorldGeotokens | null
  constructor(geotokens?: XyoWorldGeotokens | null) {
    super()
    this.geotokens = geotokens
  }

  public async filteredList(_filter?: EntityType) {
    const result: XyoWorldEntity[] = []
    const entities = await this.getEntities()
    if (entities) {
      for (const entry of entities) {
        result.push(entry[1])
      }
    }
    return result
  }

  public async getEntities() {
    if (!this.entities) {
      this.entities = new Map<string, XyoWorldEntity>()
      const geotokenList = this.geotokens?.listGeotokens() ?? []
      for (const geotoken of geotokenList) {
        const owner = await geotoken.getOwner()
        if (owner) {
          const address = owner?.toString()
          if (address) {
            this.entities.set(address, this.entities.get(address) ?? new XyoWorldEntity(owner))
          }
        }
      }
    }
    return this.entities
  }

  loadJsonObject(_jsonObject?: EntitiesJsonObject) {
    return this
  }

  public sortedList(order?: EntitySortOrder, filter?: EntityType) {
    return this.filteredList(filter)
  }

  toJsonObject(): EntitiesJsonObject {
    return {}
  }
}

export default Entities
